export default __webpack_public_path__ + "static/media/tp.5eb515ff.svg";